import MenuToggle from '@/components/pages/product/ProductsContent/TopMenuSection/MenuToggle';
import React, { useState } from 'react';
import styles from '../styles.module.css';
import PageSubMenu from '@/components/common/PageSubMenu';
interface menu {}
export default function ShopMenuSection({
  menu,
  activeMenu,
}: {
  menu?: menu[];
  activeMenu?: number | string;
}) {
  return (
    <>
      <MenuToggle
        data={menu}
        activeId={activeMenu}
        className={`${styles.menu}`}
        activeStyle={`${styles.activeMenuStyle}`}
      />
    </>
  );
}
